import { render, staticRenderFns } from "./VersionModalCounter.vue?vue&type=template&id=651329aa&scoped=true"
import script from "./VersionModalCounter.vue?vue&type=script&lang=js"
export * from "./VersionModalCounter.vue?vue&type=script&lang=js"
import style0 from "./VersionModalCounter.vue?vue&type=style&index=0&id=651329aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651329aa",
  null
  
)

export default component.exports